import { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Typography,
  Avatar,
  TextField,
} from "@mui/material";
import moment from "moment";

const MoveAppointmentDialogTratamento = ({
  open,
  onClose,
  onConfirm,
  event,
  availableDoctors,
  isLoading = false,
}) => {
  const [selectedDoctor, setSelectedDoctor] = useState("");
  const [startDate, setStartDate] = useState(
    event
      ? moment(event.start).format("YYYY-MM-DDTHH:mm")
      : moment().format("YYYY-MM-DDTHH:mm")
  );
  const [endDate, setEndDate] = useState(
    event
      ? moment(event.end).format("YYYY-MM-DDTHH:mm")
      : moment().format("YYYY-MM-DDTHH:mm")
  );
  const [error, setError] = useState("");

  const handleDoctorChange = (doctorId) => {
    setSelectedDoctor(doctorId);
    setError("");
    // Não alterar as datas - manter duração original
  };

  const handleStartDateChange = (newDateString) => {
    setStartDate(newDateString);

    // SEMPRE manter a duração original do agendamento
    const originalDuration = event
      ? moment(event.end).diff(moment(event.start), "minutes")
      : 30;

    const newEndDate = moment(newDateString).add(originalDuration, "minutes");
    setEndDate(newEndDate.format("YYYY-MM-DDTHH:mm"));
  };

  const validateAndConfirm = () => {
    if (!selectedDoctor) {
      setError("Por favor, selecione um médico.");
      return;
    }

    if (!startDate || !endDate) {
      setError("Por favor, preencha as datas.");
      return;
    }

    const startMoment = moment(startDate);
    const endMoment = moment(endDate);

    if (!startMoment.isValid() || !endMoment.isValid()) {
      setError("Por favor, verifique as datas selecionadas.");
      return;
    }

    if (endMoment.isSameOrBefore(startMoment)) {
      setError("A data final deve ser posterior à data inicial.");
      return;
    }

    const model = event.extendedProps.inTransition
      ? "AgendamentosEmTransicao"
      : event.extendedProps.isCompromisso
      ? "Compromisso"
      : event.extendedProps.isTratamentoIsolado
      ? "TratamentoIsolado"
      : "AgendaTratamento";

    onConfirm(
      {
        targetDoctorId: selectedDoctor,
        newStartDate: startMoment.toDate(),
        newEndDate: endMoment.toDate(),
        model: model,
      },
      event
    );
  };

  const handleClose = () => {
    setSelectedDoctor("");
    setError("");
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Typography variant="h6" component="div">
          Mover Agendamento
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          {event?.title}
        </Typography>
      </DialogTitle>

      <DialogContent sx={{ pt: 2 }}>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
          {/* Seleção do Médico */}
          <FormControl fullWidth>
            <InputLabel>Médico de Destino*</InputLabel>
            <Select
              value={selectedDoctor}
              onChange={(e) => handleDoctorChange(e.target.value)}
              label="Médico de Destino*"
            >
              {availableDoctors.map((doctor) => (
                <MenuItem key={doctor.id} value={doctor.id}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Avatar
                      sx={{
                        width: 24,
                        height: 24,
                        bgcolor: doctor.cor,
                        fontSize: 12,
                      }}
                    >
                      {doctor.nomeAbreviado.charAt(0)}
                    </Avatar>
                    <Typography>{doctor.nome}</Typography>
                    <Typography variant="caption" color="text.secondary">
                      ({doctor.duracaoConsulta}min)
                    </Typography>
                  </Box>
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* Data e Hora */}
          <Box sx={{ display: "flex", gap: 2 }}>
            <TextField
              label="Data/Hora Início"
              type="datetime-local"
              value={startDate}
              onChange={(e) => handleStartDateChange(e.target.value)}
              InputLabelProps={{
                shrink: true,
              }}
              sx={{ flex: 1 }}
            />

            <TextField
              label="Data/Hora Fim"
              type="datetime-local"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              InputLabelProps={{
                shrink: true,
              }}
              sx={{ flex: 1 }}
            />
          </Box>

          {/* Mensagem de erro */}
          {error && (
            <Typography color="error" variant="body2">
              {error}
            </Typography>
          )}
        </Box>
      </DialogContent>

      <DialogActions sx={{ p: 3, pt: 1 }}>
        <Button onClick={handleClose} disabled={isLoading}>
          Cancelar
        </Button>
        <Button
          onClick={validateAndConfirm}
          variant="contained"
          disabled={isLoading}
        >
          {isLoading ? "Movendo..." : "Mover Agendamento"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MoveAppointmentDialogTratamento;
